export default __webpack_public_path__ + "static/media/Govardhan-1@2x.486a6283.png";